import { useEffect, useState } from 'react';
import {
  clearTopLevelBullhornEmbedSession,
  isBullhornEmbedRoute,
  isBullhornEmbedSession,
  isInIframe,
  markBullhornEmbedSession,
} from 'utils/bullhornEmbed';

/**
 * True while the app is framed by Bullhorn. Handshake routes mark the
 * session so Firefox (no ancestorOrigins) keeps embed chrome after the
 * iframe navigates to a job page. A top-level Tenzo tab never stays in
 * embed mode, even if a stale sessionStorage flag is left over.
 */
export const useBullhornEmbedMode = (pathname: string): boolean => {
  const [isBullhornEmbedMode, setIsBullhornEmbedMode] = useState(() => {
    clearTopLevelBullhornEmbedSession();
    if (isBullhornEmbedRoute(pathname) && isInIframe()) {
      markBullhornEmbedSession();
      return true;
    }
    return isBullhornEmbedSession();
  });

  useEffect(() => {
    clearTopLevelBullhornEmbedSession();
    if (isBullhornEmbedRoute(pathname) && isInIframe()) {
      markBullhornEmbedSession();
      setIsBullhornEmbedMode(true);
      return;
    }

    setIsBullhornEmbedMode(isBullhornEmbedSession());
  }, [pathname]);

  return isBullhornEmbedMode;
};
